import React from 'react';
import { motion } from 'framer-motion';
import { WhatsAppIcon } from './icons';

export function WhatsAppButton() {
  const whatsappNumber = '+919354785960';
  const whatsappUrl = `https://wa.me/${whatsappNumber}`;

  return (
    <motion.a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-8 right-8 z-50 bg-green-500 text-white p-4 rounded-full shadow-lg hover:bg-green-600 transition-colors"
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.9 }}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
    >
      <WhatsAppIcon className="w-8 h-8" />
    </motion.a>
  );
}